export default {
    active_sessions: "Faol seanslar",
    ask_for_details_on_response: "Javob berishda tafsilotlarni so'rang",
    browser: "Browser",
    browser_data: "Browser ma'lumotlari",
    current_session: "Joriy seans",
    delete_all_sessions_except_current: "Joriy seansni istisno qilgan barcha seanslarni o'chirish",
    delete_attachment: "Ilovani o'chirish",
    delete_signed: "Imzolanmaganlarni o'chirish",
    failed_login_attempts: "Muvaffaqiyatsiz kirish urinishlari",
    finished_sessions: "Yakunlangan seanslar",
    last_use: "Oxirgi foydalanish",
    login_attempt: "Kirish urinishi",
    operating_system: "Operatsion tizim",
    password_expires_in_days: "Parolingiz bugun tugaydi | Parolingiz {day} kundan keyin tugaydi | Parolingiz {day} kundan keyin tugaydi",
    password_valid_until_note: "Joriy parolning amal qilish muddati:",
    question_for_women_only: "Faqat ayollar uchun savol",
    reset_questionnaire_fill: "So'rovnomani to'ldirishni tiklash",
    sessions: "Seanslar",
    tell_more: "Batafsil aytib bering",
    wrong_password: "Noto'g'ri parol",
    "2fa_failed": "Ikki faktorli autentifikatsiya xatosi"
}
